import { IconButton, SvgComment, TextButton, Tooltip } from '@loomhq/lens';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import { videoPlayerEnterCommentMode } from 'creators/videoPlayer';

import useMedia from 'hooks/useMedia';

import styles from './styles.module.less';

const CommentButton = props => {
  const {
    onEmbedPlayer,
    disabled,
    buttonText,
    tooltipPlacement,
    fromEndScreen,
    forceSmallIcon,
  } = props;
  const dispatch = useDispatch();

  const fullSize = useMedia(['(min-width: 560px)'], [true], false);
  let iconButtonSize = fullSize ? 'medium' : 'small';

  if (forceSmallIcon) {
    iconButtonSize = 'small';
  }

  const enterCommentMode = () => {
    dispatch(videoPlayerEnterCommentMode(fromEndScreen));
  };

  function renderAsTextButton() {
    return (
      <TextButton
        data-testid="comment-reaction-button"
        isDisabled={disabled}
        altText="Leave a comment"
        onClick={enterCommentMode}
        size={iconButtonSize}
        icon={<SvgComment color={onEmbedPlayer ? 'white' : null} />}
      >
        {buttonText}
      </TextButton>
    );
  }

  function renderAsIconButton() {
    return (
      <IconButton
        data-testid="comment-reaction-button"
        isDisabled={disabled}
        altText="Leave a comment"
        onClick={enterCommentMode}
        size={iconButtonSize}
        icon={<SvgComment color={onEmbedPlayer ? 'white' : null} />}
      >
        Comment
      </IconButton>
    );
  }

  const buttonComponent = buttonText
    ? renderAsTextButton()
    : renderAsIconButton();

  return (
    <div className={styles.commentTooltip}>
      {disabled ? (
        buttonComponent
      ) : (
        <Tooltip placement={tooltipPlacement} content="Comment (c)">
          {buttonComponent}
        </Tooltip>
      )}
    </div>
  );
};

CommentButton.propTypes = {
  tooltipPlacement: PropTypes.oneOf(['topCenter', 'bottomCenter']),
  fromEndScreen: PropTypes.bool,
};

CommentButton.defaultProps = {
  tooltipPlacement: 'topCenter',
  fromEndScreen: false,
};

export default CommentButton;
